import { theme } from "tailwind.config";
import IconInfo from "@/assets/imgs/svg/icon-info.svg";
import { FC, ReactNode } from "react";

type Props = {
  message: ReactNode;
};

const ImportantMessage: FC<Props> = ({ message }) => {
  return (
    <div className="grid grid-cols-[auto_1fr] p-12 rounded-xs text-sm gap-12 bg-main">
      <IconInfo width={24} height={24} fill={theme.colors.brand.black} />
      <p>{message}</p>
    </div>
  );
};
export default ImportantMessage;
